import { setRangeMin } from './helpers';

export const setMinArea = setRangeMin('total_area');
